export default __webpack_public_path__ + "static/media/Vector.cbf043ea.svg";